module.exports = __webpack_public_path__ + "assets/img/4.71670efd.png";